import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";

const InfoModal = ({ show, handleClose, infoMessage, redirect }) => {
  const navigate = useNavigate();
  if (!show) return null;

  const handleBack = () => {
    handleClose();

    if(redirect){
        navigate(redirect);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(107, 114, 128, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="modal-dialog" >
        <div
          className="modal-content"
          style={{
            borderRadius: "24px",
            padding: "36px 53px",
            backgroundColor: "#FFF",
            border: "1px solid rgba(0, 0, 0, 0.175)",
            // maxWidth: "90%",
            minWidth: "400px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              style={{
                fontSize: "77px",
                color: "#0ea5e9",
              }}
            />

            <p style={{ color: "#495057", fontSize: "32px", fontWeight: "500" }}>
              Information
            </p>

            <p
              style={{
                color: "#495057",
                fontSize: "16px",
                fontWeight: "500",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {infoMessage || "Please review the information before continuing"}
            </p>

            <button
              type="button"
              className="flex btn btn-submit w-[133px] h-[33px] !rounded-[8px] items-center justify-center mt-6"
              onClick={handleBack}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;